import { useDispatch, useSelector } from 'react-redux';
import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { showModalAction } from 'Store/modules/app/actions';
import { userStageSelector } from 'Store/modules/validations/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { createURL } from 'Containers/Plans/utils';
import { FRONT_PLANS, getPlanToUpperCase, parsePlans, PLANS_MODE } from 'Constants/plans';
import { PAYMENT_METHOD_MODAL } from 'Constants/modals';
import { routes } from 'Constants/routes';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { notFlowStages } from 'Constants/stages';
import { PlansType } from 'Types/common';
import PlanPrice from '../PlanPrice';
import PlansInfo from '../Bullets';
import * as Styled from './styles';
import { CardPlanPropsType } from './types';
import ButtonPlan from './ButtonPlan';

const CardPlan = ({ plan, plansAmount, planSelect }: CardPlanPropsType): JSX.Element => {
  const { t } = useTranslation();
  const stage = useSelector(userStageSelector);
  const successUrl = createURL(routes.CHECKOUT_SUCCESS_STEP, { plans: plan.name });
  const cancelUrl = createURL(routes.PLANS);
  const dispatch = useDispatch();
  const handleClick = (clickedPlan: PlansType): void => {
    dispatch(
      showModalAction({
        options: {
          type: PAYMENT_METHOD_MODAL,
          data: {
            plan: parsePlans(clickedPlan.name),
            successUrl,
            cancelUrl,
            upsellingProps: clickedPlan,
          },
        },
      })
    );
  };

  const userHaveDiscount = plan?.price?.amount !== plan?.priceUser?.amount;

  const isRecommended = planSelect && parsePlans(planSelect) === parsePlans(plan.name);
  const planMode = PLANS_MODE[parsePlans(plan.name)];
  return (
    <Styled.Container amount={plansAmount}>
      <Styled.Recommended isRecommended={isRecommended}>
        <Text type="paragraphs" size="M_M_S" color="light" align="center">
          {t('Upselling.recommended')}
        </Text>
      </Styled.Recommended>
      <FlexContainer direction="column" gap="dimension_16" align="center">
        <Styled.BackgroundImage plan={planMode}>
          <img src={`${TAXDOWN_ASSETS_DOMAIN}/mx/${planMode}.png`} alt={planMode} />
        </Styled.BackgroundImage>
        <FlexContainer align="center" direction="column">
          <FlexContainer align="center" gap="dimension_04">
            <img
              src={`${TAXDOWN_ASSETS_DOMAIN}/plans/smart-filter/v2/${planMode}_logo.svg`}
              alt={`${plan?.name}_logo`}
            />
            <Text type="headline" size="S_L_M" color="dark">
              {getPlanToUpperCase(parsePlans(plan.name))}
            </Text>
          </FlexContainer>
          <Text type="paragraphs" size="L_M_S" color="dark" align="center">
            {plan?.description}
          </Text>
        </FlexContainer>
        <PlanPrice
          finalPrice={plan?.priceUser?.amountDecimal}
          service={planMode}
          userHaveDiscount={userHaveDiscount}
          realPrice={plan?.price?.amountDecimal}
        />
        <PlansInfo service={planMode} />
        <ButtonPlan
          disabled={!plan.available || plan.price.amount === 0}
          name={plan.name}
          subscribed={plan.subscribed || plan.price.amount === 0}
          subscribedFull={plan.subscribedFull}
          onClick={() => handleClick(plan)}
        />
        {parsePlans(plan.name) === FRONT_PLANS.FLEX &&
          stage &&
          notFlowStages[stage?.toUpperCase()] && (
            <Text type="paragraphs" color="grey" size="XS_M_S" align="center">
              {t('plans:Plans.payLater.info')}
            </Text>
          )}
      </FlexContainer>
    </Styled.Container>
  );
};

export default CardPlan;
